import { cn } from "./cn";

/** The house spinner: a thin ring with one lit arc. Takes the current text colour. */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn(
        "inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent opacity-90 [animation-duration:700ms]",
        className,
      )}
    />
  );
}
